/* Errores de envío de WhatsApp que se avisan con un mensaje claro y cortan la acción (no son fallas técnicas).
   Los lanza ChatsService antes de mandar; las pantallas los reconocen con `instanceof WspSendBlockedError`
   y muestran `toast` en lugar del error genérico. Hoy son: sin saldo (NoMessageBalanceError, message-balance.ts)
   y WhatsApp desconectado (WspDisconnectedError, AF327) */
export abstract class WspSendBlockedError extends Error {
    abstract get toast(): { severity: string; summary: string; detail: string; life?: number };
}

/* No se envía porque el WhatsApp de la administración está desconectado o sin configurar (WspStatusService) */
export class WspDisconnectedError extends WspSendBlockedError {
    constructor(public reason: string = '') {
        super('No se pudo enviar: tu WhatsApp está desconectado.');
        this.name = 'WspDisconnectedError';
        Object.setPrototypeOf(this, WspDisconnectedError.prototype);
    }

    get toast() {
        return {
            severity: 'error',
            summary: 'WhatsApp desconectado',
            //el motivo, si es otro (sin configurar, número no dado de alta), va después
            detail: this.message + (this.reason ? ' ' + this.reason : ''),
            life: 10000,
        };
    }
}
